import React from 'react';
import { Label } from './ui/label.jsx';
import { Input } from './ui/input.jsx';

const ControllerSection = ({ controller, setController }) => {
  const handleChange = (field, value) => {
    setController(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 mb-4">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Controller Setup</h2>
      <div className="space-y-4">
        <div>
          <Label htmlFor="controller-name">Name</Label>
          <Input
            id="controller-name"
            value={controller.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Suite Processor Name"
            data-testid="controller-name"
          />
        </div>
        <div>
          <Label htmlFor="controller-ip">IP Address</Label>
          <Input
            id="controller-ip"
            value={controller.ip_address}
            onChange={(e) => handleChange('ip_address', e.target.value)}
            placeholder="192.168.1.100"
            data-testid="controller-ip"
          />
        </div>
        <div>
          <Label htmlFor="controller-subnet">Subnet Mask</Label>
          <Input
            id="controller-subnet"
            value={controller.subnet}
            onChange={(e) => handleChange('subnet', e.target.value)}
            placeholder="255.255.255.0"
            data-testid="controller-subnet"
          />
        </div>
        <div>
          <Label htmlFor="controller-gateway">Gateway</Label>
          <Input
            id="controller-gateway"
            value={controller.gateway}
            onChange={(e) => handleChange('gateway', e.target.value)}
            placeholder="192.168.1.1"
            data-testid="controller-gateway"
          />
        </div>
        <div>
          <Label htmlFor="controller-dns">DNS Server</Label>
          <Input
            id="controller-dns"
            value={controller.dns}
            onChange={(e) => handleChange('dns', e.target.value)}
            placeholder="8.8.8.8"
            data-testid="controller-dns"
          />
        </div>
      </div>
    </div>
  );
};

export default ControllerSection;